export const LITMOS_TITLE = "title.litmos";

